import selectors from '../../../../redux/selectors/Index.js';

export default {
  selectPassenger,
  onRouteIdChange,
};

function selectPassenger (id) {
  let { flights, passengers, routeId } = this.state;
  let selectedPassenger;
  let passengerExist = false;
  passengers.find(passenger => {
    if (passenger.id === id) {
      passenger.selected = !passenger.selected;
      selectedPassenger = passenger;
    }
  });
  flights.find(flight => {
    if (flight.routeId === routeId) {
      flight.passengers.find(passenger => {
        if (passenger.id === id) {
          passenger.selected = !passenger.selected;
          passengerExist = true;
        }
      });

      if (!passengerExist && selectedPassenger) {
        let newFlightPassenger = {
          id: selectedPassenger.id,
          selected: selectedPassenger.selected,
        };
        flight.passengers.push(newFlightPassenger);
      }
    }
  });

  this.setState({ passengers, flights });
}

function onRouteIdChange (props) {
  let { flights, routeId, isFetching } = props;
  let stateFlights = this.state.flights;
  let flightsLoaded = flights && flights.length;
  let meals = [];
  let selectedMeals = [];
  if (!isFetching && flightsLoaded) {
    if (stateFlights && stateFlights.length) {
      meals = selectors.meals.getMeals(stateFlights, routeId);
      selectedMeals = selectors.meals.getSelectedMeals(stateFlights, routeId);
    }
    this.setState({ flights, meals, selectedMeals, routeId });
  } else {
    this.setState({ routeId });
  }
}



// WEBPACK FOOTER //
// ./src/containers/meals/common/mealsList/MealsListController.js